/* eslint-disable import/no-anonymous-default-export */
export default (allRequest = [], action) => {
  switch (action.type) {
    case "GET_ALL_LOCATIONS_REQUEST":
      return action.payload;

    case "DELETE_ALL_LOCATIONS_REQUEST":
      return allRequest.map((data) => {
        return {
          ...data,
          request: data.request.filter((item) => item._id !== action.payload),
        };
      });
    case "UPDATE REQUEST":
      return allRequest.map((data) => {
        return {
          ...data,
          request: data.request.filter((item) => item._id !== action.payload),
        };
      });

    default:
      return allRequest;
  }
};
